import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
    EurekaCircleCheck,
    EurekaTriangleAlert,
} from '@Green-Dot-Corporation/eureka-ui-icons';
import { Heading } from '@Green-Dot-Corporation/eureka-ui-typography';
import CalloutActions from './CalloutActions';

// Constants
import VARIANTS from './const/variantsConst';

// Styles
import './styles/callout.scss';

const { AFFIRMATIVE, ERROR } = VARIANTS;

class Callout extends PureComponent {
    static defaultProps = {
        headingLvl: 2,
        actions: [],
        shouldPadContent: true,
        onActionClick: () => Promise.resolve(),
    };

    static propTypes = {
        titleId: PropTypes.string,
        msgId: PropTypes.string,
        contextCls: PropTypes.string,
        variant: PropTypes.string,
        headingLvl: PropTypes.number,
        actions: PropTypes.array,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        msg: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        shouldPadContent: PropTypes.bool,
        onActionClick: PropTypes.func,
        renderIcon: PropTypes.func,
    };

    render() {
        const {
            contextCls,
            actions,
            renderIcon,
            variant,
            title,
            msg,
            onActionClick,
            children,
        } = this.props;
        const shouldRenderIcon = !!renderIcon || !!variant;
        const shouldRenderActions = actions.length > 0;
        const modCls = this.getModCls();

        return (
            <div className={cx(this.baseCls, modCls, contextCls)}>
                <div className={`${this.baseCls}__inner`}>
                    {!children && (
                        <Fragment>
                            {shouldRenderIcon && this.renderIcon()}
                            {(title || msg) && this.renderMessaging()}
                            {shouldRenderActions && (
                                <CalloutActions
                                    actions={actions}
                                    onActionClick={onActionClick}
                                />
                            )}
                        </Fragment>
                    )}
                    {children}
                </div>
            </div>
        );
    }

    renderIcon = () => {
        const { renderIcon } = this.props;

        return (
            <div className={`${this.baseCls}__icon-container`}>
                {renderIcon ? renderIcon() : this.renderStatusIcon()}
            </div>
        );
    };

    renderStatusIcon = (iconCls) => {
        const { variant } = this.props;
        // const iconCls = `${this.baseCls}__icon`;
        let Icon;

        switch (variant) {
            case VARIANTS.AFFIRMATIVE:
                Icon = EurekaCircleCheck;
                break;

            default:
                Icon = EurekaTriangleAlert;
                break;
        }

        return <Icon contextCls={iconCls} />;
    };

    renderMessaging = () => {
        const { titleId, msgId, title, msg, headingLvl } = this.props;

        const titleProps = {
            contextCls: `${this.baseCls}__title`,
            headingLvl,
            ...(titleId && { id: titleId }),
        };

        const msgProps = {
            className: `${this.baseCls}__msg-container-inner`,
            ...(msgId && { id: msgId }),
        };

        return (
            <div className={`${this.baseCls}__text-container`}>
                {title && (
                    <div className={`${this.baseCls}__title-container`}>
                        <Heading {...titleProps}>{title}</Heading>
                    </div>
                )}
                {msg && (
                    <div className={`${this.baseCls}__msg-container`}>
                        <div {...msgProps}>{msg}</div>
                    </div>
                )}
            </div>
        );
    };

    getModCls = () => {
        const { variant, shouldPadContent } = this.props;

        return {
            [`${this.baseCls}--affirmative`]: variant === AFFIRMATIVE,
            [`${this.baseCls}--error`]: variant === ERROR,
            [`${this.baseCls}--pad-content`]: shouldPadContent,
        };
    };

    baseCls = 'eureka-callout';
}

export default Callout;
